'use strict';

module.exports = function(Handlebars) {
  Handlebars.registerHelper('if_eq', function(value, test, options) {
    if (value === test) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('if_not_eq', function(value, test, options) {
    if (value !== test) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('if_gt', function(value, test, options) {
    if (value > test) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('if_lt', function(value, test, options) {
    if (value < test) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('if_any', function() {
    let options = arguments[arguments.length - 1];
    // iterate all the things except the options hash
    for (let i = 0; i < arguments.length - 1; i++) {
      if (arguments[i]) {
        return options.fn(this);
      }
    }
    return options.inverse(this);
  });

  Handlebars.registerHelper('if_all', function() {
    let options = arguments[arguments.length - 1];
    // iterate all the things except the options hash
    for (let i = 0; i < arguments.length - 1; i++) {
      if (!arguments[i]) {
        return options.inverse(this);
      }
    }
    return options.fn(this);
  });

  Handlebars.registerHelper('if_gte', function(value, test, options) {
    if (value >= test) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('if_lte', function(value, test, options) {
    if (value <= test) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });
};



// WEBPACK FOOTER //
// ./assets/js/handlebars-helpers/comparisons.js